var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "calendar--month" },
    [
      _c("h4", { staticClass: "calendar--title" }, [
        _vm._v(_vm._s(_vm.month.title)),
      ]),
      _vm._v(" "),
      _vm._l(_vm.dayHeaders, function (dayHeader, index) {
        return _c("span", { key: index, staticClass: "calendar--header" }, [
          _vm._v(_vm._s(dayHeader)),
        ])
      }),
      _vm._v(" "),
      _vm._l(_vm.month.weeks, function (week) {
        return _vm._l(week, function (day) {
          return _c("hotel-calendar-day", {
            key: day.KEY,
            attrs: { day: day },
            on: {
              close: function ($event) {
                return _vm.$emit("close")
              },
            },
            nativeOn: {
              keydown: function ($event) {
                return _vm.handleDayKeydown($event, day)
              },
            },
          })
        })
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }